import React from 'react';
import { Row, Col } from 'antd';
import { Organization } from 'models/CompanySetup/organization.model';
import { OrgBoundaryEnum } from 'enums/organisationMapEnums';
import OrganisationMapReactFlow from 'views/CompanySetup/OrganisationMap/OrganisationReactFlow';
import OrganisationViewNode from 'views/CompanySetup/OrganisationMap/OrganisationMapNodes/OrganisationViewNode';
import { initialEdges, initialNodes } from '../nodes';
import styles from '../appComponents.module.scss';
import COButton from 'shared/components/COButton';
import ValidationModal from 'views/CompanySetup/OrganisationMap/EditOrganisationMap/OrganizationDisableValidationModal';

const OrganizationMapComponent: React.FC = () => {
  const [visible, setVisible] = React.useState<boolean>(false);

  const toggleVisibility = () => setVisible(prev => !prev);

  return (
    <>
      <div className={styles.reactFlowMap} id="organisationMapReactFlowWrapper">
        <OrganisationMapReactFlow
          initialNodes={initialNodes}
          initialEdges={initialEdges}
        />
      </div>
      <Row gutter={[30, 30]}>
        <Col>
          <OrganisationViewNode
            organisation={{
              ...new Organization(),
              id: 1,
              name: 'Holland Organization',
              organisationYearWise: {
                id: 1,
                parentName: null,
                isParent: true,
                organizationShare: 20,
                year: 2020,
                totalLocations: 13,
                isActive: true,
              },
            }}
          />
        </Col>
        <Col>
          <OrganisationViewNode
            organisation={{
              ...new Organization(),
              id: 2,
              name: 'Holland America',
              organisationYearWise: {
                id: 2,
                parentName: 'Holland Organization',
                organizationShare: 35,
                year: 2020,
                isActive: true,
                totalLocations: 13,
              },
            }}
            shareType={OrgBoundaryEnum.Equity}
          />
        </Col>
      </Row>
      <COButton primary onClick={toggleVisibility}>
        Organization In-active Validation Modal
      </COButton>
      <ValidationModal isOpen={visible} onClose={toggleVisibility} />
    </>
  );
};

export default OrganizationMapComponent;
